<template>
  <div>
    <head-public title="校派"></head-public>
    <!-- 背景图 -->
<div class="bg">
	<!-- 介绍内容 -->
	<div class="upon">
		<div class="note">校派 | 泰国皇家师范大学</div>
		<div class="title1"></div>
		<div class="title2"></div>
		<div class="abroad"></div>
		<div class="content">
			<div>泰国皇家师范大学探秘</div>
			<div>解锁快乐留学密码</div>
			<div class="blank">5天4夜体验营，高三学生0元限</div>
			<div>时抢购</div>
			<div class="blank">课程学习+文化探索</div>
			<div>边游边学边玩，一次妙趣横生的游学之旅</div>
			<div class="blank">泰国皇家师范大学学习，与当地学生0距离互动</div>
			<div>中英泰多语言授课，体验侵入式课堂</div>
			<div>深度参观学习，解锁地道泰式文化</div>
			<div>游玩泰国著名城市，探享曼谷风情</div>
		</div>
		<div class="remark">备注：本次游学之旅<text>仅限高三学生参加</text>，本次活动最终解释权归校派所有</div>
	</div>
	<!-- 表单信息 -->
	<div class="under">
		<div class="frame">
			<div class="dialogue">立即报名参与泰国0元游学旅</div>
			<div class="inf">
				<input type="text" class="inf-item" placeholder="姓名" placeholder-style="color:#aaa;" v-model="name"/>
				<!-- <picker mode="selector" @click="bindSex" value="{{sex}}" range="{{arrSex}}">
          <div class="inf-item" wx:if="{{sex}}">{{sex}}</div>
          <div class="pick inf-item" wx:else>性别</div>
        </picker> -->
				<input type="number" class="inf-item" placeholder="联系方式" placeholder-style="color:#aaa;" v-model="phone"/>
				<input type="text" class="inf-item" placeholder="就读学校" placeholder-style="color:#aaa;" v-model="school"/>
				<input type="text" class="inf-item" placeholder="就读年级" placeholder-style="color:#aaa;" v-model="grade"/>
				<input type="text" class="inf-item" placeholder="居住地区" placeholder-style="color:#aaa;" v-model="region"/>
			</div>
			<div class="btn" @click="signUp">立即报名</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {httpPost} from "../../axios/index";
import headPublic from "../../components/publicHead"
export default {
  data(){
    return{
        phone:"",//联系方式
        name:"", //姓名
        school:"", //就读学校
        grade:"",//就读年级
        region:"",//居住地区
    }
  },
  methods: {
    // 点击报名
  signUp(){
    httpPost("/abroad/baoming",{
      name:this.name,
      mobile:this.phone,
      school:this.school,
      grade:this.grade,
      region:this.region
    }).then(res=>{
      if(res.code==1){
        this.$toast.success(res.msg);
      }else{
        this.$toast.fail(res.msg);
      }
    })
  }
},
mounted () {
  
},
components:{
    headPublic
}
}
</script>

<style scoped>
  .bg {
  width: 100%;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/abroadBg.png);
  background-size: 100%;
  margin-top: 46px;
}

.upon {
  box-sizing: border-box;
  width:100%;
  padding-left: 0.625rem;
  padding-top: 1.875rem;
  border-bottom: 0.0625rem dashed #fff;
  position: relative;
}

.note {
  font-size: 0.75rem;
  color: #ffffff;
}

.title1 {
  width: 9.0625rem;
  height: 4rem;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/abroadText1.png);
  background-size: 100%;
  margin-top: 5rem;
  /* z-index: 999; */
}

.title2 {
  width: 10rem;
  height: 6.25rem;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/abroadText2.png) no-repeat;
  background-size: 100%;
  margin-top: 2.1875rem;
  /* z-index: 999; */
}

.abroad {
  width: 15.625rem;
  height: 31.6875rem;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/abroad.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 3.4375rem;
  right: 0;
  z-index: -1;
}

.content {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #ffffff;
  margin-top: 2.9375rem;
}

.blank {
  margin-top: 1.5625rem;
}

.remark {
  margin-top:2.75rem;
  margin-bottom: 1.4375rem;
  font-size: 0.75rem;
  color: #ffffff;
}

.remark text {
  font-weight: bolder;
}

.under {
  width: 23.4375rem;
  box-sizing: border-box;
  padding-bottom: 1.25rem;
  padding-top: 1.875rem;
}

.frame {
  width: 22.25rem;
  height: 35rem;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/frame.png) no-repeat;
  background-size: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 2.6875rem 0;
}

.dialogue {
  width: 18.6875rem;
  height: 4.375rem;
  background: url(https://new.schoolpi.net/attach/small_program/abroad/dialogue.png) no-repeat;
  background-size: 100%;
  font-size: 1.125rem;
  font-weight: bold;
  color: #4e0277;
  line-height: 3.125rem;
  text-align: center;
  margin: 0 auto;
}

.inf {
  margin-top: 0.875rem;
}

.inf-item {
  width: 18.8125rem;
  height: 2.75rem;
  line-height: 2.75rem;
  background-color: #ffffff;
  border-radius: 0.625rem;
  margin: 0 auto 0.625rem;
  font-size: 0.9375rem;
  font-weight: bold;
  color: #000000;
  padding-left: 0.625rem;
  box-sizing: border-box;
  margin-left: 1.75rem;
}
.pick{
  color: #aaa;
}
.btn {
  width: 18.8125rem;
  height: 2.75rem;
  line-height: 2.75rem;
  background-color: #ff6959;
  border-radius: 0.625rem;
  margin: 1.875rem auto 0;
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
}
</style>